import React, { ReactNode, useContext, useMemo } from 'react';
import GameContext from '../context/GameContext';
import { whiteWinPct } from './winChance';

// Horizontal eval bar with each side's win chance inside its segment. The viewer's side (bottom of the
// board) sits on the left, and the fill is its win chance.
export default function GamesListItemEvaluationBar(): ReactNode {
  const { currentMove, orientation, analysisWhiteWin } = useContext(GameContext);
  // A dragged position's live engine result wins; otherwise the stored evaluation. A forced mate pins
  // the bar to 0 or 100.
  const white = useMemo(
    () =>
      analysisWhiteWin != null
        ? analysisWhiteWin
        : whiteWinPct(currentMove?.Evaluation, currentMove?.MateIn),
    [analysisWhiteWin, currentMove?.Evaluation, currentMove?.MateIn],
  );
  const black = 100 - white;
  const viewerIsWhite = orientation === 'white';
  const leftPct = viewerIsWhite ? white : black;
  const rightPct = 100 - leftPct;
  return (
    <div
      className={`cm-eval-bar${viewerIsWhite ? '' : ' viewer-black'}`}
      role="progressbar"
      aria-valuenow={white}
      aria-valuemin={0}
      aria-valuemax={100}
      title={`White ${white}% · Black ${black}%`}
    >
      <div className="cm-eval-left" style={{ width: `${leftPct}%` }}>
        <span className="cm-eval-num">{leftPct}%</span>
      </div>
      <span className="cm-eval-num cm-eval-right-num">{rightPct}%</span>
    </div>
  );
}
